import axios from 'axios';
import { ApiConfig } from '../constants/apiConfig';

export const studentAuthorizationHeaders = (extra = {}) => {
  const token = localStorage.getItem('student_token');
  if (!token) throw new Error('Sesi login berakhir. Silakan login kembali.');
  return { Authorization: `Bearer ${token}`, Accept: 'application/json', ...extra };
};

export const clearStudentSession = () => {
  localStorage.clear();
};

export const validateStudentSession = async () => {
  const token = localStorage.getItem('student_token');
  if (!token) return false;
  try {
    await axios.get(`${ApiConfig.baseUrl}/session`, {
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
      timeout: 10000,
    });
  } catch (error) {
    if (error.response?.status === 401 && localStorage.getItem('student_token') === token) {
      clearStudentSession();
      return false;
    }
    // Connection problems and rate limits must not log out the student.
  }
  return true;
};

export const guruAuthorizationHeaders = (extra = {}) => {
  const token = localStorage.getItem('guru_api_token');
  if (!token) throw new Error('Sesi Guru berakhir. Silakan login kembali.');
  return { Authorization: `Bearer ${token}`, Accept: 'application/json', ...extra };
};

export const logoutStudent = async () => {
  const token = localStorage.getItem('student_token');
  try {
    await axios.post(`${ApiConfig.baseUrl}/logout`, null, {
      headers: studentAuthorizationHeaders(),
      timeout: 15000,
    });
  } catch (_) {
    // Clear the local session even when the network is unavailable.
  } finally {
    if (localStorage.getItem('student_token') === token) clearStudentSession();
  }
};

// Fungsi Login
export const login = async (nisn, password) => {
  const url = `${ApiConfig.baseUrl}/login`;

  try {
    const response = await axios.post(
      url,
      new URLSearchParams({
        nisn,
        password,
      }),
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );

    const responseData = response.data;

    if (response.status === 200 && responseData.success === true) {
      // Simpan ke localStorage
      clearStudentSession();
      localStorage.setItem('user_id', parseInt(responseData.user_id) || 0);
      localStorage.setItem('student_token', responseData.token || '');
      localStorage.setItem('account_type', 'siswa');
      localStorage.setItem('nama', responseData.nama || '');
      localStorage.setItem('kelas', responseData.kelas || '');
      localStorage.setItem('jurusan', responseData.jurusan || '');
      localStorage.setItem('tempat_pkl', responseData.tempat_pkl || '');
      localStorage.setItem(
        'guru_pembimbing_id',
        parseInt(responseData.guru_pembimbing_id) || 0
      );
      localStorage.setItem(
        'tempat_pkl_id',
        parseInt(responseData.tempat_pkl_id) || 0
      );

      return { success: true, message: 'Login berhasil' };
    } else {
      return {
        success: false,
        message: responseData.message || 'Login gagal. Periksa NISN dan Password.',
      };
    }
  } catch (error) {
    const rawMessage = error.response?.data?.message;
    const errMessage = typeof rawMessage === 'string'
      ? rawMessage
      : rawMessage
        ? Object.values(rawMessage).flat().filter(Boolean).join(' ')
        : 'Login gagal. Periksa NISN dan Password.';

    return {
      success: false,
      message: errMessage,
    };
  }
};

export const loginGuru = async (nip, password) => {
  try {
    const response = await axios.post(
      `${ApiConfig.baseUrl}/guru/login`,
      new URLSearchParams({ nip, password }),
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const data = response.data;
    if (response.status !== 200 || data.success !== true || !data.token) {
      return { success: false, message: data.message || 'Login Guru gagal.' };
    }

    clearStudentSession();
    const profile = data.data || {};
    localStorage.setItem('account_type', 'guru');
    localStorage.setItem('guru_api_token', data.token);
    localStorage.setItem('guru_id', String(profile.id || ''));
    localStorage.setItem('guru_nip', profile.nip || nip);
    localStorage.setItem('guru_nama', profile.nama_guru || 'Guru Pembimbing');
    return { success: true, message: data.message || 'Login Guru berhasil.' };
  } catch (error) {
    const rawMessage = error.response?.data?.message;
    const message = typeof rawMessage === 'string'
      ? rawMessage
      : rawMessage
        ? Object.values(rawMessage).flat().filter(Boolean).join(' ')
        : 'Tidak dapat terhubung ke server. Coba lagi.';
    return { success: false, message };
  }
};

export const logoutGuru = async () => {
  try {
    await axios.post(`${ApiConfig.baseUrl}/guru/logout`, null, {
      headers: guruAuthorizationHeaders(),
    });
  } catch (_) {
    // Always clear the local session when logout is requested.
  } finally {
    clearStudentSession();
  }
};

// Fungsi Reset Password
export const resetPassword = async (id, newPassword, confirmPassword) => {
  const url = `${ApiConfig.baseUrl}/resetPassword`;
  const token = localStorage.getItem('student_token');
  if (!token) {
    return {
      success: false,
      message: 'Sesi login berakhir. Silakan login kembali.',
    };
  }

  try {
    const response = await axios.post(
      url,
      new URLSearchParams({
        id,
        new_password: newPassword,
        new_password_confirmation: confirmPassword,
      }),
      {
        headers: {
          ...studentAuthorizationHeaders(),
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );

    return {
      success: true,
      message: response.data.message,
    };
  } catch (error) {
    const res = error.response;
    let message = 'Terjadi kesalahan saat mereset kata sandi.';

    if (res?.data?.message) {
      message =
        typeof res.data.message === 'string'
          ? res.data.message
          : Object.values(res.data.message).join(' ');
    }

    return {
      success: false,
      message,
    };
  }
};
